import React from 'react';
import { css } from 'aphrodite';
import styles from './welcome-styles';
import Login from '../login/login';

const Welcome = () => (
  <div className={css(styles.root)}>
    <img src={require('../../assets/kiffgo/logo-green.svg')} className={css(styles.logo)} />
    <Login/>
  </div>
);

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/welcome/welcome.js